import { useQuery } from '@tanstack/react-query';
import {
  ALL_CONNECTION_QUERY_KEY,
  TELEPHONE_MUTATION_KEY,
} from 'constants/QueryKeys.constants';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';
import type { QueryOptionsFor } from 'hooks/api/types';
import useProjectRoute from 'hooks/useProjectRoute';

interface UseConnectionTokens {
  options?: QueryOptionsFor<typeof api.getAllConnectionTokens>;
}

export const useConnectionTokens = ({ options }: UseConnectionTokens = {}) => {
  const api = useApi();
  const { accountId, projectId } = useProjectRoute();

  return useQuery({
    queryKey: [
      accountId,
      projectId,
      TELEPHONE_MUTATION_KEY,
      ALL_CONNECTION_QUERY_KEY,
    ],
    queryFn: () => api.methods.getAllConnectionTokens(accountId, projectId),
    refetchOnWindowFocus: false,
    ...options,
  });
};
